import { render, staticRenderFns } from "./ComparativaMaquinas.vue?vue&type=template&id=026c97d0&"
import script from "./ComparativaMaquinas.vue?vue&type=script&lang=js&"
export * from "./ComparativaMaquinas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports